<template>
  <div class="help-center card">
    <main class="card-body main">
      <div class="help-center__title">Create question category</div>
      <div
        class="input-wrapper"
        v-for="domain in domains"
        :key="domain.language"
      >
        <div class="input__title">
          {{ `Title ${domain.language.toUpperCase()}` }} 
          <span v-if="domain.language === 'en'"> (required field)</span>
        </div>
          <base-input
            class="input"
            v-model="title[domain.language]"
          ></base-input>
      </div>
      <div class="help-center__button-wrapper">
        <button class="btn btn-primary" @click.prevent="handleCreate">
          Create
        </button>
      </div>
    </main>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    title: {}
  }),
  computed: {
    ...mapState("cmsApiCatalogs", ["domains"])
  },
  methods: {
    ...mapActions("helpCenterCategories", ["createCategory"]),
    ...mapActions("cmsApiCatalogs", ["getDomains"]),
    async handleCreate() {
      if(!this.title.en){
      return this.$notify({ type: "warning", title: "EN field cannot be empty" });
      }
      this.$store.dispatch("setLoader", true);
      await this.createCategory({
        title: this.title
      })
        .then(response => {
          this.$router.push("list");
          this.$notify({
            type: "success",
            title: "Question category has been created"
          });
        })
        .catch(err => {
          this.$notify({ type: "warning", title: "Error" });
        })
        .finally(() => {
          this.$store.dispatch("setLoader", false);
        });
    }
  },
  created() {
    this.getDomains();
  }
};
</script>
